import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserDashboard from './components/UserDashboard/UserDashboard';
import { BookingsProvider } from './components/UserDashboard/BookingContext';
import PageNotFound from '../PageNotFound/PageNotFound';

const Timeline = (props) => {

    if (props?.access && props?.access?.timeline) {

        const currentDate = new Date();
        const currentHour = currentDate.getHours();
        const currentMinute = currentDate.getMinutes();

        const initialDate =
            currentHour > 23 || (currentHour === 23 && currentMinute >= 45)
                ? new Date(currentDate.setDate(currentDate.getDate() + 1))
                : currentDate;


        return <>
            <BookingsProvider initUser={props.user} initialDate={initialDate}>
                <UserDashboard />
            </BookingsProvider>
        </>;
    }
    else {
        return <PageNotFound fitToMenu />
    }

};

Timeline.propTypes = {
    userType: PropTypes.string,
    user: PropTypes.object,
    access: PropTypes.object
};

const mapStateToProps = (state) => ({
    userType: state.auth && state.auth.user ? state.auth.user.type : null,
    user: state.auth && state.auth.user ? state.auth.user : null,
    access: state.auth && state.auth.user ? state.auth.user.access : null,
});

export default connect(mapStateToProps)(Timeline);
